// import logo from './logo.svg';
import './App.css';
import AllRoute from './AllRoute';
import { useIsLoading } from './utils/useIsLoading';
import Loading from './components/Loading';



function App() {
const {isLoading}=useIsLoading();
  console.log(isLoading,'isLoading')
  return (
    <div>
      {isLoading&&<Loading/>}
      <AllRoute />
    </div>
  );
}

export default App;
